module.exports = __webpack_public_path__ + "static/media/book.b7ec53a3.svg";